import React from 'react';
import {
  Checkbox,
  Group,
  Text,
  TextInput,
  UnstyledButton,
  Select,
} from '@mantine/core';
import { TbTrashXFilled } from 'react-icons/tb';
import { IconPlus } from '@tabler/icons-react';
import { useEmployeeFormContext } from '../NewEmployeePage';
import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';

export const EducationCard: React.FC = () => {
  const form = useEmployeeFormContext();

  // Načtení jazyků z API pomocí useSWR
  const { data: languages, error } = useSWR('/employees/languages', getFetcher);

  // Ošetření případné chyby při načítání
  if (error) {
    return <div>Error loading languages</div>;
  }

  // Kontrola, zda jsou data načtena
  if (!languages) {
    return <div>Loading languages...</div>;
  }

  // Vytvoření možností pro Select z dat, konverze id na string
  const languageOptions = languages.map((lang: any) => ({
    value: String(lang.id), // Převedení ID na řetězec
    label: lang.name,
  }));

  const handleCreateLang = (): void => {
    const newLanguage = {
      id: 0, // ID nového jazyka bude nastaveno na 0 dokud uživatel nevybere
      level: '',
    };
    form.insertListItem('langs', newLanguage);
  };

  const handleDeleteLang = (index: number) => {
    form.removeListItem('langs', index);
  };

  const showLangs = () => {
    return form.values.langs.length === 0 ? null : (
      <table className="mt-3">
        <thead>
          <tr>
            <th className="text-left">Jazyk</th>
            <th className="text-left">Znalost</th>
          </tr>
        </thead>
        <tbody>{langRows}</tbody>
      </table>
    );
  };

  const langRows = form.values.langs.map((lang: any, index: number) => (
    <tr key={index}>
      <td style={{ width: '60%' }} className="pr-3 pt-3">
        {/* Select pro výběr jazyka, nyní ukládáme id místo name */}
        <Select
          data={languageOptions}
          placeholder="Vyberte jazyk"
          radius="md"
          variant="filled"
          value={String(lang.id)} // Select pracuje s hodnotou id
          onChange={value =>
            form.setFieldValue(`langs.${index}.id`, Number(value))
          } // Ulož id místo name
        />
      </td>
      <td style={{ width: '40%' }} className="pr-3 pt-3">
        <TextInput
          variant="filled"
          radius="md"
          placeholder="Úroveň znalosti"
          {...form.getInputProps(`langs.${index}.level`)}
        />
      </td>
      <td className="pt-3">
        <UnstyledButton onClick={() => handleDeleteLang(index)}>
          <TbTrashXFilled size="28" />
        </UnstyledButton>
      </td>
    </tr>
  ));

  return (
    <div>
      <Text fw={700} size="lg" mt="lg">
        Vzdělání
      </Text>
      <TextInput
        required
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="Typ"
        label="Typ"
        {...form.getInputProps('eduType')}
      />
      <Checkbox
        size="sm"
        mt="md"
        mb="md"
        labelPosition="left"
        label="Může poskytnout první pomoc"
        checked={form.values.canFirstAid}
        {...form.getInputProps('canFirstAid')}
      />

      <Group justify="space-between" mt="lg">
        <Text fw={700} size="lg">
          Jazyky
        </Text>
        <UnstyledButton onClick={handleCreateLang}>
          <IconPlus />
        </UnstyledButton>
      </Group>
      {showLangs()}
    </div>
  );
};
